// extracted by mini-css-extract-plugin
export default {"label":"RInputField_label__Iggng","field":"RInputField_field__X+AD6"};